import { render, staticRenderFns } from "./CardCategoryCreate.vue?vue&type=template&id=5d0c4972&scoped=true&"
import script from "./CardCategoryCreate.vue?vue&type=script&lang=js&"
export * from "./CardCategoryCreate.vue?vue&type=script&lang=js&"
import style0 from "./CardCategoryCreate.vue?vue&type=style&index=0&id=5d0c4972&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0c4972",
  null
  
)

export default component.exports
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QInput,QIcon,QBtn,QToggle,QCardSection});
